import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PlanningCreatePage } from './planning-create';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    PlanningCreatePage,
  ],
  imports: [
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    IonicPageModule.forChild(PlanningCreatePage),
  ],
})
export class PlanningCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/planning-create/planning-create.module.ts